export const PRODUCT_TYPES = [
  { value: "GOODS", label: "Goods" },
  { value: "SERVICES", label: "Services" },
];

export const TAX_BASE_TYPES = [
  { label: "products.placeholders.decimal", value: "DECIMAL" },
  {
    label: "products.placeholders.percentage",
    value: "PERCENTAGE",
  },
  {
    label: "products.placeholders.fraction",
    value: "FRACTION",
  },
];
